import React from 'react';
import { motion } from 'framer-motion';
// --- Assuming PortfolioTimeline uses the complex background internally ---
import PortfolioTimeline from '../components/homepage/PortfolioTimeline';
import FeaturedPortfolio from '../components/homepage/FeaturedPortfolio';

const Portfolio = () => {
    const introText = "Amama Ventures invests across stages where conviction and contribution compound—optimizing for long-term founder relationships and category creation.";

    return (
        <motion.div
            // --- UPDATED: Fixed typo "16ss" to "16" ---
            className="bg-background pt-12 md:pt-16"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            {/* Intro text section */}
            <div className="container mx-auto px-6 mb-16">
                {/* --- UPDATED: Added text-center and flex alignment --- */}
                <div className="max-w-6xl mx-auto text-center flex flex-col items-center"> 
                    <motion.h1
                        className="text-4xl md:text-5xl font-bold text-foreground mb-6 font-serif"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, delay: 0.2 }}
                    >
                        Portfolio
                    </motion.h1>

                    {/* Intro Text Wrapper */}
                    {/* --- UPDATED: Replaced TextRevealOnScroll with motion.p and centered it --- */}
                    <motion.p 
                        className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, delay: 0.4 }} // Slight delay after title
                    >
                        {introText}
                    </motion.p>
                </div>
            </div>

            {/* --- PortfolioTimeline Component --- */}
            <div className="mt-0">
                <PortfolioTimeline />
            </div>

            <div className="mt-0"> 
                <FeaturedPortfolio />
            </div>

        </motion.div>
    );
};

export default Portfolio;